<template>
    <div class="aia-header">
        <div class="aia-back"
            @click="clickBack">
            <img class="img-fluid" src="@/assets/icon/ic-back@3x.png" />
        </div>
        <div id="prestige_logo" class="aia-logo">
            <img class="img-fluid img-sharpen" src="@/assets/logo/prestige/logo-prestige@3x.png" />
        </div>
        <div class="aia-search"
            @click="clickSearch()">
            <img src="../../../../assets/icon/ic_search.svg" />
        </div>
    </div>
</template>
<script>
export default {
    name: 'PrestigeHeader',
    methods: {
        //event
        clickBack: function () {
            this.$emit('clickBack');
        },
        clickSearch: function () {
            this.$router.push('/search');
        }
    }
}
</script>
<style lang="scss" scoped>
@import "../AIAHeader.scss";
.aia-header {
    background-color: $prestige_theme_color;

    #prestige_logo {
        width: 100px;
        // width: calc(100% / 3);
    }
}
</style>
